<template>
    <div class="user-headline-with-tooltip">
        <slot name="icon"></slot>
        <h2 class="user-headline"><span :class="'icon-' + icon"></span> <span v-html="title"></span></h2>
        <span class="icon-info" v-tooltip="{ content: $t(tooltipMessage), html: true }"></span>
    </div>
</template>

<script>
    export default {
        name: 'totem-subheader',
        props: {
            title: String,
            icon: String,
            tooltipMessage: String
        }
    }
</script>

<style lang="scss" scoped>
    .user-headline-with-tooltip {
        position: relative;
        gap: 10px;
        display: flex;
        align-items: center;
        padding: 30px 0;

        h2 {
            font-family: 'QuickSand-Bold';
            margin-left: 0.6rem;
        }
    }

    .icon-info {
        font-size: 2rem;
        display: flex;
        align-items: center;

        [class*="mobile"] & {
        display: none;
        }
    }

    .icon-crown {
        font-size: 2rem;
        margin: 0 10px 0 0;
    }
</style>
